module.exports = __webpack_public_path__ + "static/agriculture-6954abe26a2239961eee42d19458678d.png";